<div class="ods">
  <img *ngFor="let odsNumber of odsNumbers" [src]="'assets/img/ods_new/' + odsNumber + '.webp'"
    [alt]="'ODS ' + odsNumber" [matTooltip]="getOdsName(odsNumber)" [class.clickable]="isClickable(odsNumber)"
    class="ods-image" (click)="onOdsClick($event, odsNumber)" />
  <span *ngIf="!hasOds">

  </span>
</div>